export default __webpack_public_path__ + "static/media/flash.96e141d3.png";